


















import { defineComponent, PropType } from '@nuxtjs/composition-api';
import BaseSelectOption from '@shared/components/@atoms/BaseSelectOption/BaseSelectOption.vue';
import BaseSelect from '@shared/components/@molecules/BaseSelect/BaseSelect.vue';

import { IContactFormField } from '../types';

export default defineComponent({
  name: 'ContactFormEnquiryV1Field',
  components: {
    BaseSelect,
    BaseSelectOption,
  },
  props: {
    field: {
      type: Object as PropType<IContactFormField>,
      required: true,
    },
  },
  data() {
    return {
      selectionValue: '',
    };
  },
  methods: {
    onSelect() {
      const inputField = this.field;
      inputField.value = this.field.dropdownOptions[this.selectionValue as unknown as number].label;
      inputField.mappedLabel = this.field.label;
      this.$emit('updated-input', inputField);
    },
  },
});
